import { jsx as _jsx } from "react/jsx-runtime";
import '@/styles/Common/MarkdownRenderer.less';
import Markdown from 'react-markdown';
import rehypeRaw from 'rehype-raw';
import remarkBreaks from 'remark-breaks';
import remarkGfm from 'remark-gfm';
const MarkdownRenderer = ({ value }) => (_jsx("div", { className: "markdown-renderer", children: _jsx(Markdown, { remarkPlugins: [remarkGfm, remarkBreaks], rehypePlugins: [rehypeRaw], children: value }) }));
export default MarkdownRenderer;
